import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Alert, H3, NewButton, Icon } from '../../../../../components';

const AssetErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledAlert = styled(Alert)`
  margin-top: 14px;
  margin-bottom: 20px;
`;

const AssetErrorActionsContainer = styled.div`
  display: flex;
`;

const AssetError = ({ questionBody, answerBody, actions = null, onRetryQuestion }) => (
  <AssetErrorContainer>
    <H3>{questionBody}</H3>
    <StyledAlert
      actions={actions}
      message={answerBody}
      icon={<Icon name='alert' color='var(--content-body)' />}
    />
    <AssetErrorActionsContainer>
      <NewButton onClick={onRetryQuestion}>
        <Icon name='sync' />
        Retry
      </NewButton>
    </AssetErrorActionsContainer>
  </AssetErrorContainer>
);

AssetError.propTypes = {
  questionBody: PropTypes.string.isRequired,
  actions: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  answerBody: PropTypes.string.isRequired,
  onRetryQuestion: PropTypes.func.isRequired
};

export { AssetError };
